exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.lottery_tabs[data-v-bcec77b6] {\n  padding: 12px;\n}\n", ""]);

// exports
